import { render, staticRenderFns } from "./list-item.vue?vue&type=template&id=fb6b0ca6&"
import script from "./list-item.vue?vue&type=script&lang=js&"
export * from "./list-item.vue?vue&type=script&lang=js&"
import style0 from "./list-item.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fb6b0ca6')) {
      api.createRecord('fb6b0ca6', component.options)
    } else {
      api.reload('fb6b0ca6', component.options)
    }
    module.hot.accept("./list-item.vue?vue&type=template&id=fb6b0ca6&", function () {
      api.rerender('fb6b0ca6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/footer/list-item.vue"
export default component.exports